import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SortBot } from '../../../app/helpers/sort';
import { EmailTemplateBasicsItemArray, EmailTemplateBasicsItem } from '../../../app/models/domain/email.template.basics.item';
import { TemplateTypes } from '../../../app/models/domain/email.template.item';
import { emailTemplatesListFilter } from '../../../app/pipes/filter.pipe';
import { EditEmailTemplateDialog } from '../../../app/dialogs/edit.email.template/edit.email.template.dialog';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { SendEmailRequest } from '../../../app/models/ss-api/requests/send.email.request';
import { EmailTemplateFullItem } from '../../../app/models/domain/email.template.full.item';
import { EmailPreviewDialog } from '../../../app/dialogs/email.preview/email.preview.dialog';
import { AddEmailTemplateDialog } from '../../../app/dialogs/add.email.template/add.email.template.dialog';
import { DuplicateEmailTemplateRequest } from '@models/ss-api/requests/duplicate.email.template.request';

class FilterOption {
    label: string;
    value: number;
}

@Component({
    selector: 'email-templates-list',
    templateUrl: './email.templates.list.component.html',
    styleUrls: ['./email.templates.list.component.css']
})

export class EmailTemplatesListComponent implements OnInit {
    IsBusy: boolean = false;

    Templates: EmailTemplateBasicsItemArray;
    OriginalTemplates: EmailTemplateBasicsItemArray;

    EmailTemplateFilter: string = '';
    filter: emailTemplatesListFilter = new emailTemplatesListFilter();
    filterOptions: Array<FilterOption> = new Array<FilterOption>();
    selectedFilters: Array<FilterOption> = new Array<FilterOption>();

    constructor(private dialogService: DialogService, private api: ssApiService, private GlobalService: GlobalService, private sweetAlert: SweetAlertService) {
        this.filterOptions = [
            {
                label: 'Customer Service', value: 0
            },
            {
                label: 'System', value: 1
            },
            {
                label: 'Tech Support', value: 2
            },
            {
                label: 'Training', value: 3
            },
            {
                label: 'Account Management', value: 5
            }
        ];
    }

    sortByName() { this.Templates = SortBot.SortAuto<EmailTemplateBasicsItemArray>(this.filter.transform(this.Templates, this.EmailTemplateFilter), 'Name'); }
    sortByType() { this.Templates = SortBot.SortAuto<EmailTemplateBasicsItemArray>(this.filter.transform(this.Templates, this.EmailTemplateFilter), 'TemplateType'); }
    sortByDate() { this.Templates = SortBot.SortAuto<EmailTemplateBasicsItemArray>(this.filter.transform(this.Templates, this.EmailTemplateFilter), 'LastUpdated'); }

    ngOnInit() {
        this.GlobalService.SetPageTitle('Email Templates');
        // this.IsBusy = true;
        this.LoadTemplates();
    }

    LoadTemplates() {
        this.IsBusy = true;
        let disposable = this.api.GetEmailTemplatesBasicsAndFrom().subscribe(response => {
            this.Templates = response.Data.Templates;
            this.OriginalTemplates = response.Data.Templates;
            this.IsBusy = false;

            this.onFilterChange();
            disposable.unsubscribe();
        });
    }

    EditEmailTemplate(template: EmailTemplateBasicsItem) {
        let options = {
            height: 800
        };
        let disposable = this.dialogService.addDialog(EditEmailTemplateDialog, {
            Title: 'Edit Email Template',
            Template: template
        }, options).subscribe(response => {
            if (response) {
                this.LoadTemplates();
            }
            disposable.unsubscribe();
        });
    }

    AddEmailTemplate() {
        let options = {
            height: 800
        };
        let disposable = this.dialogService.addDialog(AddEmailTemplateDialog, {
            Title: 'Add Email Template'
        }, options).subscribe(response => {
            if (response) {
                this.LoadTemplates();
            }
            disposable.unsubscribe();
        });
    }


	DuplicateEmailTemplate( template: EmailTemplateBasicsItem ){
        var request = new DuplicateEmailTemplateRequest();
        request.EmailTemplateID = template.ID;
        
        var sub2 = this.api.DuplicateEmailTemplate(request).subscribe(result => {

            sub2.unsubscribe();

			if (result.Result) {
				this.sweetAlert.swal({
					title: 'Email Duplicated Successfuly',
					text: 'Email duplicated as "Duplicate of ' + template.Name +'."',
					type: 'success',
					showCancelButton: false,
					showConfirmButton: false,
					timer: 1500
				});

				this.LoadTemplates();

			} else {
				this.sweetAlert.swal({
					type: 'error',
					title: 'Duplicate Email Failed',
					text: result.Data
				});
			}

            console.log("DuplicateEmailTemplate=>", result);
        }, error => {

		}); 

	}


    SendTest(template: EmailTemplateBasicsItem) {
        let ActiveTemplate: EmailTemplateFullItem;
        let disposable = this.api.GetEmailTemplateHTML(template.ID).subscribe(response => {
            ActiveTemplate = response.Data;
            disposable.unsubscribe();
        });

        this.sweetAlert.swal(
            {
                title: 'Send Test Email',
                text: '',
                input: 'text',
                inputValue: '',
                inputPlaceholder: 'Email address',
                showCancelButton: true,
                preConfirm: (response) => {
                    let request: SendEmailRequest = {
                        Body: ActiveTemplate.Body,
                        FromEmail: 'support@structurestudios.com',
                        MemberID: null,
                        Subject: ActiveTemplate.Subject,
                        ToBCC: [],
                        ToCC: [],
                        ToEmail: [response]
                    };

                    return this.api.SendEmail(request).toPromise();
                }
            }).then((response: any) => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        title: 'Test Email Sent',
                        text: 'Please check your inbox to see the test email.',
                        type: 'success'
                    });
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Test Email Failed',
                        text: response.Data
                    });
                }
            }, (dismiss) => {
                return;
            }
            );
    }

    PreviewTemplate(template: EmailTemplateBasicsItem) {
        let disposable = this.api.GetEmailTemplateHTML(template.ID).subscribe(response => {
            let options = {
                height: 800
            };
            let tempDialog = this.dialogService.addDialog(EmailPreviewDialog, {
                emailContent: response.Data.Body,
                emailSubject: response.Data.Subject
            }, options).subscribe(result => {
                tempDialog.unsubscribe();
                disposable.unsubscribe();
            });
        });
    }

    TypeNameForTemplate(type: TemplateTypes) {
        switch (type) {
            case 0:
                return 'Customer Service';
            case 1:
                return 'System';
            case 2:
                return 'Tech Support';
            case 3:
                return 'Training';
            case 4:
                return 'Transaction';
            case 5:
                return 'Account Management';
        }
    }

    onFilterChange(event?) {
        if (!event) event = this.selectedFilters;
        if (event.length == 0) {
            this.Templates = this.OriginalTemplates;
        } else {
            this.Templates = this.OriginalTemplates.filter(function (e) {
                if (event != undefined && event.indexOf(e.TemplateType) < 0) {
                    return false;
                }
                return true;
            }) as EmailTemplateBasicsItemArray;
        }
    }

}
